let origin = "https://future.zhuneng.cn";

//获取商品详情
const getGoodsDetailUrl = `/gateway/hc-serve/miniapi/pointsMall/goodsDetailById`;

//订单详情页
const getOrderDetailUrl = `/gateway/hc-serve/miniapi/pointsMall/userPointExchangeDetail`;

//核销
const handleOrderUrl = `/gateway/hc-serve/miniapi/pointsMall/sceneOrderCompletedByShop`;
//运动打卡列表【分页】
const getSportListUrl = `/gateway/hc-health/manageapi/healthRecord/listPaging`;
//运动打卡审核
const verifyUrl = `/gateway/hc-health/manageapi/healthRecord/audit`;
//运动打卡详情
const getSportDetailUrl = `/gateway/hc-health/manageapi/healthRecord/detailById`;
export {
  verifyUrl,
  getSportListUrl,
  getGoodsDetailUrl,
  getOrderDetailUrl,
  handleOrderUrl,
  getSportDetailUrl,
};
